import React from "react";

const checkCircle = (
    <path
        fillRule="evenodd"
        d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm3.844-8.791a.75.75 0 0 0-1.188-.918l-3.7 4.79-1.649-1.833a.75.75 0 1 0-1.114 1.004l2.25 2.5a.75.75 0 0 0 1.15-.043l4.25-5.5Z"
        clipRule="evenodd"
    />
);

const questionMarkCircle = (
    <path
        fillRule="evenodd"
        d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0Zm-6 3.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7.293 5.293a1 1 0 1 1 .99 1.667c-.459.134-1.033.566-1.033 1.29v.25a.75.75 0 1 0 1.5 0v-.115a2.5 2.5 0 1 0-2.518-4.153.75.75 0 1 0 1.061 1.06Z"
        clipRule="evenodd"
    />
);

const exclamationCircle = (
    <path
        fillRule="evenodd"
        d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM8 4a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3A.75.75 0 0 1 8 4Zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clipRule="evenodd"
    />
);

function StatusIcon({ path, style }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
            aria-hidden="true"
            focusable="false"
            style={style}>
            {path}
        </svg>
    );
}

const statusLookup = {
    normal: { icon: checkCircle, label: "Normal", colour: "#14532d", bgColour: "#bbf7d0" },
    warning: { icon: questionMarkCircle, label: "Warning", colour: "#7c2d12", bgColour: "#fed7aa" },
    critical: { icon: exclamationCircle, label: "Critical", colour: "#7f1d1d", bgColour: "#fecaca" },
};

export function StatusTag({ status, children }) {
    const config = statusLookup[status];

    if (!config) return null;

    const { icon: Icon, label: defaultLabel, colour, bgColour } = config;

    return (
        <div
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 4,
                padding: "0 4px 0px 2px",
                borderRadius: "99999px",
                color: colour,
                backgroundColor: bgColour,
                fontSize: 12,
            }}>
            <StatusIcon
                path={Icon}
                style={{ width: 16, height: 16 }}
            />
            <span>{children ?? defaultLabel}</span>
        </div>
    );
}
